// import React, { useState, useEffect, useRef } from "react";
// import { Form, Select, Button } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { getStates } from "../features/statecity/statecitySlice";
// import { getUsers } from "../features/cutomers/customerSlice";
// import { getClusters } from "../features/cluster/clusterSlice";
// import { Chart } from "chart.js/auto";

// const OjtInternship = () => {
//   const chartInstanceRef = useRef(null);
//   const [chart, setChart] = useState(null);
//   const [vcData, setvcData] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedVC, setselectedVC] = useState("");
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();

//   const statelistState = useSelector(
//     (state) => state.statecity.statelist || []
//   );
//   const vclistState = useSelector((state) => state.customer.customers || []);
//   const clusterlistState = useSelector((state) => state.cluster.cluster);

//   useEffect(() => {
//     dispatch(getStates());
//     dispatch(getUsers());
//     dispatch(getClusters());
//   }, [dispatch]);

//   const handleStateChange = (value) => {
//     const vcfilterData = vclistState.filter(
//       (customer) => customer.state === value
//     );
//     setvcData(vcfilterData);
//     setSelectedState(value);
//   };

//   const handleVcChange = (value) => {
//     setselectedVC(value);
//   };

//   const handleClear = () => {
//     form.resetFields();
//     setSelectedState("");
//     setselectedVC("");
//     setvcData([]);
//   };

//   const chartData = {
//     labels: ["Aditya", "Sarbani", "Raghav"],
//     datasets: [
//       {
//         label: "Number of OJTs",
//         data: [8, 10, 7],
//         backgroundColor: ["#4ade80", "#4ade80", "#4ade80"],
//         hoverBackgroundColor: ["#16a34a", "#16a34a", "#16a34a"],
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     plugins: {
//       tooltip: {
//         callbacks: {
//           label: function (tooltipItem) {
//             const vcIndex = tooltipItem.dataIndex;
//             const jobRoles = [
//               "Apparel: Sewing Machine Operator (3), Assistant Fashion Designer (2)",
//               "IT/ITeS: CRM Associate (5), Data Entry Operator (5)",
//               "Apparel: Quality Inspector (4), Tailor (3)",
//             ];
//             return `Trade: ${jobRoles[vcIndex]}`;
//           },
//         },
//       },
//       legend: {
//         display: false,
//       },
//     },
//     scales: {
//       x: {
//         title: {
//           display: true,
//           text: "VC Names",
//         },
//       },
//       y: {
//         title: {
//           display: true,
//           text: "Number of OJTs",
//         },
//         ticks: {
//           stepSize: 1,
//         },
//       },
//     },
//   };

//   useEffect(() => {
//     if (!chart) {
//       const ctx = chartInstanceRef.current.getContext("2d");
//       const ojtInternship = new Chart(ctx, {
//         type: "bar",
//         data: chartData,
//         options: chartOptions,
//       });
//       setChart(ojtInternship);
//     }
//   }, []);

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         {/* Title Section */}
//         <h4
//           style={{
//             textAlign: "left",
//             fontWeight: "bold",
//             fontSize: "large",
//             marginBottom: "0.5rem",
//           }}
//         >
//           OJT/Internship Process
//         </h4>
//         <p
//           style={{
//             color: "#6b7280",
//             fontSize: "0.875rem",
//             textAlign: "right",
//           }}
//         >
//           Last Updated: 10:30 AM
//         </p>
//       </div>

//       {/* Filter Section */}
//       <Form
//         form={form}
//         layout="inline"
//         // onFinish={handleSubmit}
//         style={{ marginTop: "20px", marginLeft: "100px" }}
//       >
//         <Form.Item
//           name="state_name"
//           rules={[
//             {
//               required: true,
//               message: "Please Select State!",
//             },
//           ]}
//         >
//           <Select
//             style={{ width: 160 }}
//             placeholder="Select State"
//             value={selectedState}
//             onChange={handleStateChange}
//           >
//             <Select.Option key="default" value="">
//               Select State
//             </Select.Option>
//             {statelistState.map((i, j) => (
//               <Select.Option key={j} value={i.state}>
//                 {i.state_name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>
//         <Form.Item name="cluster">
//           <Select placeholder="Select Cluster" style={{ width: 150 }}>
//             {clusterlistState.map((cluster) => (
//               <Select.Option key={cluster._id} value={cluster._id}>
//                 {cluster.name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>
//         <Form.Item
//           name="vc_name"
//           rules={[
//             {
//               required: true,
//               message: "Please Select VC!",
//             },
//           ]}
//         >
//           <Select
//             style={{ width: 160 }}
//             placeholder="Select VC"
//             value={selectedVC}
//             onChange={handleVcChange}
//           >
//             <Select.Option key="default" value="">
//               Select VC
//             </Select.Option>
//             {vcData
//               .filter((item) => item.role === "vc")
//               .map((item) => (
//                 <Select.Option key={item._id} value={item._id}>
//                   {item.name}
//                 </Select.Option>
//               ))}
//           </Select>
//         </Form.Item>
//         <Form.Item>
//           <Button
//             style={{
//               backgroundColor: "#28a745",
//               color: "#fff",
//               marginTop: 16,
//               marginLeft: 135,
//             }}
//             htmlType="submit"
//           >
//             Apply Filter
//           </Button>
//         </Form.Item>

//         <Form.Item>
//           <Button
//             style={{
//               backgroundColor: "#dc3545",
//               color: "#fff",
//               marginTop: 16,
//             }}
//             onClick={handleClear}
//           >
//             Reset Filter
//           </Button>
//         </Form.Item>
//       </Form>

//       {/* Graph Section */}
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "0.5rem",
//           boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//           padding: "1rem",
//           marginTop: "1.5rem",
//         }}
//       >
//         <h2
//           style={{
//             color: "#1d4ed8",
//             fontWeight: "bold",
//             fontSize: "1.125rem",
//             marginBottom: "16px",
//           }}
//         >
//           OJT Numbers by Vocational Coordinator
//         </h2>
//         <canvas ref={chartInstanceRef} style={{ height: "200px" }}></canvas>
//       </div>

//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "0.5rem",
//           boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//           padding: "1rem",
//           marginTop: "1.5rem",
//         }}
//       >
//         <table
//           style={{
//             width: "100%",
//           }}
//         >
//           <thead>
//             <tr style={{ backgroundColor: "#e5e7eb" }}>
//               <th style={{ padding: "0.5rem" }}>S.No</th>
//               <th style={{ padding: "0.5rem" }}>State</th>
//               <th style={{ padding: "0.5rem" }}>Cluster</th>
//               <th style={{ padding: "0.5rem" }}>VC Name</th>
//               <th style={{ padding: "0.5rem" }}>VT Name</th>
//               <th style={{ padding: "0.5rem" }}>Trade</th>
//               <th style={{ padding: "0.5rem" }}>Job Role</th>
//               <th style={{ padding: "0.5rem" }}>Date Provided</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr style={{ backgroundColor: "#f9fafb" }}>
//               <td style={{ padding: "0.5rem" }}>1</td>
//               <td style={{ padding: "0.5rem" }}>Rajasthan</td>
//               <td style={{ padding: "0.5rem" }}>Cluster A</td>
//               <td style={{ padding: "0.5rem" }}>Aditya</td>
//               <td style={{ padding: "0.5rem" }}>Mayank</td>
//               <td style={{ padding: "0.5rem" }}>Apparel</td>
//               <td style={{ padding: "0.5rem" }}>Sewing Machine Operator</td>
//               <td style={{ padding: "0.5rem" }}>2023-01-15</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
//         <button
//           style={{
//             ...styles.button,
//             backgroundColor: "#3B82F6",
//             borderRadius: "5px",
//           }}
//         >
//           Export as PDF
//         </button>
//         <button
//           style={{
//             ...styles.button,
//             backgroundColor: "#3B82F6",
//             borderRadius: "5px",
//           }}
//         >
//           Export as CSV
//         </button>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   button: {
//     padding: "8px 12px",
//     color: "#fff",
//     border: "none",
//     cursor: "pointer",
//   },
// };

// export default OjtInternship;

import React, { useState, useEffect, useRef } from "react";
import { Form, Select, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { getClusters } from "../features/cluster/clusterSlice";
import { Chart } from "chart.js/auto";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const OjtInternship = () => {
  const chartInstanceRef = useRef(null);
  const [chart, setChart] = useState(null);
  const [vcData, setvcData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedVC, setselectedVC] = useState("");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const pdfExportRef = useRef(null);

  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  const clusterlistState = useSelector((state) => state.cluster.cluster);

  useEffect(() => {
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getClusters());
  }, [dispatch]);

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const handleVcChange = (value) => {
    setselectedVC(value);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setselectedVC("");
    setvcData([]);
  };

  const chartData = {
    labels: ["Aditya", "Sarbani", "Raghav"],
    datasets: [
      {
        label: "Number of OJTs",
        data: [8, 10, 7],
        backgroundColor: ["#4ade80", "#4ade80", "#4ade80"],
        hoverBackgroundColor: ["#16a34a", "#16a34a", "#16a34a"],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const vcIndex = tooltipItem.dataIndex;
            const jobRoles = [
              "Apparel: Sewing Machine Operator (3), Assistant Fashion Designer (2)",
              "IT/ITeS: CRM Associate (5), Data Entry Operator (5)",
              "Apparel: Quality Inspector (4), Tailor (3)",
            ];
            return `Trade: ${jobRoles[vcIndex]}`;
          },
        },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "VC Names",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of OJTs",
        },
        ticks: {
          stepSize: 1,
        },
      },
    },
  };

  useEffect(() => {
    if (!chart) {
      const ctx = chartInstanceRef.current.getContext("2d");
      const ojtInternship = new Chart(ctx, {
        type: "bar",
        data: chartData,
        options: chartOptions,
      });
      setChart(ojtInternship);
    }
  }, [chart]);

  const exportAsPDF = () => {
    const input = pdfExportRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("ojt_internship_report.pdf");
    });
  };

  return (
    <div
      style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
      ref={pdfExportRef}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* Title Section */}
        <h4
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "large",
            marginBottom: "0.5rem",
          }}
        >
          OJT/Internship Process
        </h4>
        <p
          style={{
            color: "#6b7280",
            fontSize: "0.875rem",
            textAlign: "right",
          }}
        >
          Last Updated: 10:30 AM
        </p>
      </div>

      {/* Filter Section */}
      <Form
        form={form}
        layout="inline"
        // onFinish={handleSubmit}
        style={{ marginTop: "20px", marginLeft: "100px" }}
      >
        <Form.Item
          name="state_name"
          rules={[
            {
              required: true,
              message: "Please Select State!",
            },
          ]}
        >
          <Select
            style={{ width: 160 }}
            placeholder="Select State"
            value={selectedState}
            onChange={handleStateChange}
          >
            <Select.Option key="default" value="">
              Select State
            </Select.Option>
            {statelistState.map((i, j) => (
              <Select.Option key={j} value={i.state}>
                {i.state_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="cluster">
          <Select placeholder="Select Cluster" style={{ width: 150 }}>
            {clusterlistState.map((cluster) => (
              <Select.Option key={cluster._id} value={cluster._id}>
                {cluster.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="vc_name"
          rules={[
            {
              required: true,
              message: "Please Select VC!",
            },
          ]}
        >
          <Select
            style={{ width: 160 }}
            placeholder="Select VC"
            value={selectedVC}
            onChange={handleVcChange}
          >
            <Select.Option key="default" value="">
              Select VC
            </Select.Option>
            {vcData
              .filter((item) => item.role === "vc")
              .map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              marginTop: 16,
              marginLeft: 135,
            }}
            htmlType="submit"
          >
            Apply Filter
          </Button>
        </Form.Item>

        <Form.Item>
          <Button
            style={{
              backgroundColor: "#dc3545",
              color: "#fff",
              marginTop: 16,
            }}
            onClick={handleClear}
          >
            Reset Filter
          </Button>
        </Form.Item>
      </Form>

      {/* Graph Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "0.5rem",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <h2
          style={{
            color: "#1d4ed8",
            fontWeight: "bold",
            fontSize: "1.125rem",
            marginBottom: "16px",
          }}
        >
          OJT Numbers by Vocational Coordinator
        </h2>
        <canvas ref={chartInstanceRef} style={{ height: "200px" }}></canvas>
      </div>

      <div
        className="table-container"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "0.5rem",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <table
          style={{
            width: "100%",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#e5e7eb" }}>
              <th style={{ padding: "0.5rem" }}>S.No</th>
              <th style={{ padding: "0.5rem" }}>State</th>
              <th style={{ padding: "0.5rem" }}>Cluster</th>
              <th style={{ padding: "0.5rem" }}>VC Name</th>
              <th style={{ padding: "0.5rem" }}>VT Name</th>
              <th style={{ padding: "0.5rem" }}>Trade</th>
              <th style={{ padding: "0.5rem" }}>Job Role</th>
              <th style={{ padding: "0.5rem" }}>Date Provided</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: "#f9fafb" }}>
              <td style={{ padding: "0.5rem" }}>1</td>
              <td style={{ padding: "0.5rem" }}>Rajasthan</td>
              <td style={{ padding: "0.5rem" }}>Cluster A</td>
              <td style={{ padding: "0.5rem" }}>Aditya</td>
              <td style={{ padding: "0.5rem" }}>Mayank</td>
              <td style={{ padding: "0.5rem" }}>Apparel</td>
              <td style={{ padding: "0.5rem" }}>Sewing Machine Operator</td>
              <td style={{ padding: "0.5rem" }}>2023-01-15</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
        <button
          style={{
            ...styles.button,
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
          onClick={exportAsPDF}
        >
          Export as PDF
        </button>
        <button
          style={{
            ...styles.button,
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
        >
          Export as CSV
        </button>
      </div>
    </div>
  );
};

const styles = {
  button: {
    padding: "8px 12px",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
};

export default OjtInternship;
